import { Component, OnInit } from '@angular/core'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'app-daily-log-template-name-input-modal',
  templateUrl: './daily-log-template-name-input-modal.component.html',
  styleUrls: ['./daily-log-template-name-input-modal.component.scss'],
})
export class DailyLogTemplateNameInputModalComponent implements OnInit {
  constructor(private modalService: ModalService, private logService: LogService) {}

  name: string = ''

  ngOnInit() {
    this.logService.dailyLog.logDailyLogTemplateTemplateNameInputModalViewed()
  }

  onClickClose(): void {
    this.modalService.dismiss()
  }

  onKeyUp(value: string): void {
    this.name = value
  }

  onClickSubmit(): void {
    this.logService.dailyLog.logDailyLogTemplateTemplateNameInputModalSubmitButtonClicked()
    if (this.name.trim() === '') return
    this.modalService.dismiss(this.name)
  }
}
